<div class="dialog" role="document" aria-labelledby="booking-action-title">
  <div class="dialog-header">
    <span class="dialog-title" id="booking-action-title">{{ data.title }}</span>
    <button type="button" class="close-btn" (click)="close()" aria-label="Close">×</button>
  </div>

  <div class="field">
    <label class="field-label" for="booking-action-reason">Reason</label>
    <textarea
      id="booking-action-reason"
      class="text-box-active"
      rows="4"
      placeholder="Enter a reason"
      [(ngModel)]="reason"
    ></textarea>
  </div>

  <div class="dialog-actions">
    <button type="button" class="ac-secondary-btn" (click)="close()">Close</button>
    <button type="button" class="ac-danger-btn" [disabled]="!reason.trim()" (click)="submit()">
      {{ data.actionLabel }}
    </button>
  </div>
</div>
